import axios from 'axios';
import { API_URL } from '../config/constants';

export interface ExternalBookSearchResult {
  source: 'wikisource' | 'gutenberg';
  externalId: string;
  title: string;
  author: string;
  language?: string;
  description?: string;
  sourceUrl?: string;
  detailUrl?: string;
  downloadUrl?: string | null;
  coverImageUrl?: string | null;
  fileFormat?: string;
}

interface ExternalSearchResponse {
  results: ExternalBookSearchResult[];
}

interface ExternalImportResponse {
  message: string;
  book: {
    id: number;
    title: string;
  };
}

export interface BulkImportJob {
  id: string;
  source: 'wikisource' | 'gutenberg';
  query: string;
  status: 'discovering' | 'running' | 'completed' | 'failed';
  total: number;
  processed: number;
  imported: number;
  skipped: number;
  failed: number;
  errors: Array<{ title?: string; error: string }>;
  startedAt: string;
  finishedAt: string | null;
}

export const searchExternalBooks = async (
  query: string,
  source: 'all' | 'wikisource' | 'gutenberg',
  token: string
) => {
  const response = await axios.get<ExternalSearchResponse>(`${API_URL}/books/import/search`, {
    params: {
      q: query,
      source
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return response.data.results as ExternalBookSearchResult[];
};

export const importExternalBook = async (
  source: 'wikisource' | 'gutenberg',
  externalId: string,
  token: string
) => {
  const response = await axios.post<ExternalImportResponse>(
    `${API_URL}/books/import`,
    {
      source,
      externalId
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

export const startBulkExternalImport = async (
  source: 'wikisource' | 'gutenberg',
  query: string,
  limit: number,
  token: string
) => {
  const response = await axios.post<{ job: BulkImportJob }>(
    `${API_URL}/books/import/bulk`,
    { source, query, limit },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.job;
};

export const getBulkExternalImport = async (jobId: string, token: string) => {
  const response = await axios.get<{ job: BulkImportJob }>(
    `${API_URL}/books/import/bulk/${jobId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.job;
};
